import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Container } from "@mui/material";
export default function BusinessComponent() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const clientsItems = [
   {
    description: "for organizations and employers with workers who have pets",
    link: "assets/svg/travelers.svg",
    borderColor: "border-orange",
   },
   {
    description: "for organizations looking to enhance membership benefits and people risk management",
    link: "assets/svg/management.svg",
    borderColor: "border-sky-blue",
   },
   {
    description: "programs that support the senior population",
    link: "assets/svg/programs.svg",
    borderColor: "border-green-600",
   },
   {
    description: "membership and loyalty program enhancement",
    link: "assets/svg/enhancement.svg",
    borderColor: "border-gray-900",
   },
   {
    description: "enhance health and wellness employee benefits",
    link: "assets/svg/benefits.svg",
    borderColor: "border-yellow",
   },
   {
    description: "subscription membership programs",
    link: "assets/svg/subcription.svg",
    borderColor: "border-blue",
   },
   {
    description: "shared and gig economy benefits",
    link: "assets/svg/data.svg",
    borderColor: "border-green",
   },
   {
    description: "adventure and events planning organizations",
    link: "assets/svg/adventure.svg",
    borderColor: "border-black",
   },
  ];

  const partnerDetails = [
    {
      description: "Our platform is easy to integrate into existing systems and workflows, and our team provides comprehensive support to ensure a smooth partnership. Plus, with customizable branding options, businesses can co-brand or white-label FootprintID® and FootprintId® to fit seamlessly into their existing brand identity.",
      link: "assets/images/platform.png",
    },
    {
      description: "Whether you're in the travel industry looking to provide peace of mind to your customers, an organization with a duty of care for those they work with, or a gig economy platform looking to offer valuable benefits to workers (or anything else in between), FootprintID® and FootprintId® can help.",
      link: "assets/images/industryUser.png",
    },
    {
      description: "Don't just take our word for it - we've already helped hundreds of organizations - and over 5 million users worldwide - improve health outcomes and satisfaction rates.",
      link: "assets/images/hart.png",
    },
  ];

  const partnershipDetails = [
    {
      description: "Avoid unnecessary doctor visits and spend more time focused on other tasks.",
      link: "assets/images/partnership.jpg",
      title: "Increased Productivity",
    },
    {
      description: "Get better health outcomes from more accurate diagnoses and treatment recommendations.",
      link: "assets/images/partnership1.jpg",
      title: "Improved Outcomes",
    },
    {
      description: "By avoiding unnecessary doctor visits and procedures, all parties can save money on healthcare costs.",
      link: "assets/images/partnership2.jpg",
      title: "Reduced Costs",
    },
    {
      description: "Help improve employee satisfaction and retention rates, while also attracting talent.",
      link: "assets/images/partnership3.jpg",
      title: "Attract & Retain",
    },
  ];

  return (
    <div className="container-fluid">

    <div id="home-video-main">
      <section
        className="second-sections"
      >
        <h3 className="clients-say-businesses">
          <span>What Our</span> Clients say
        </h3>
        <div>
          <div className="row flex-row clients-works-section">
            <div
              className="our-out-style col-md-6"
            >
              <div className="clients-details">
                "The team at FootprintID® has been super easy to work with and
                have made offering their product to our clients seamless. The
                product is a nice complement to our custom travel insurance
                protection plans. In my opinion, the value of the FootprintID®
                product is incredible especially when in the middle of an
                emergency and you need easy quick access to your important
                medical information."
              </div>
              <p className="clients-user-name">
                Kelly P. Sahner, Chief Commercial Officer, Tripmate
              </p>
            </div>
            <div
              className="our-out-style col-md-6"
            >
              <div className="clients-details">
                "This partnership is a natural fit for both brands as
                FootprintID® helps elevate the level of care that we provide our
                clients.when people are traveling,having ready and secure access
                to their medical information can be vitally important. knowing
                critical medical data is available at their fingertips anywhere
                in the world provides Trip mate customers with peace of mind so
                that they can enjoy their trip."
              </div>
              <p className="clients-user-name">
                Chris Carnicelli, Chief Executive Officer, Generali Global
                Assistance{" "}
              </p>
            </div>
            <div
              className="our-out-style col-md-12"
            >
              <div className="clients-details">
                "Getting good medical care starts with a picture of where you
                have been. Being able to store and share on demand medical care
                history is critical to anyone care plan. Footprint is a core
                feature for our medical plan clients."
              </div>
              <p className="clients-user-name">
                Christian R. Stearns Co-Founder, CRO &amp; Product Lead HealthEE
                by HBG
              </p>
            </div>
          </div>
        </div>
        <div className="clients-second-sections">
          <p>
            Whether you're a business, a distributor of benefits, or a
            membership-based organization, FootprintID® is an excellent benefit
            for employees, members, or as a part of any benefits program.
          </p>
        </div>
      </section>
      <section>
        <div className="members-Card-data">
          {clientsItems.map((item, index) => (
            <div key={index} className={`BusinessCard`}>
              <div className={`membersCard-inner-block ${item.borderColor}`}>
                <div className="members-card-membership">
                  <div className="members-card-item">
                    <img src={item.link} alt={item.description} />
                  </div>
                  <p className="members-card-membership-style">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
      <section>
        <h2 className="partner-sections"><span>It’s easy to</span> partner with us.</h2>
        <p className="partner-data">
          Partnering with FootprintID and FootprintId is an easy and
          cost-effective way for organizations to provide a valuable benefit
          service, while also demonstrating a commitment to health and safety.
        </p>
        <div>
           {partnerDetails.map((item, index) => (
            <div key={index} className="partner-card-block">
              <div className="partner-inner-section row flex-row">
                <div className="col-lg-1 col-md-2 col-sm-3  platform-inner-block">
                  <img src={item.link} alt={item.description} className="img-fluid"/>
                </div>
                <p className="partner-description col-lg-11 col-md-10 col-sm-9">{item.description}</p>
              </div>
            </div>
           ))}       
        </div>
      </section>
      <section className="partnership-benefits-section">
        <div className="partnership-benefits-inner">
          <h3 className="clients-say-businesses">
            <span>Partnership</span> Benefits
          </h3>
          <p className="partnership-benefits-detalis">
            Here are just a few of the benefits that organizations can expect
            from partnering with FootprintID and FootprintId:
          </p>
        </div>
      </section>
      <section
        className="partnership-content-main-card"
      >
        <div className="partnership-content-block">
          {partnershipDetails.map((item, index) => (
              <div
              key={index}
              className="partnership-content-card"
            >
              <div className="benefits-content">
                <div className="benefits-content-sections">
                  <img
                    className="img-fluid benefits-content-img"
                    src={item.link}
                    alt=""
                  />
                </div>
                <h5>
                  {item.description}
                </h5>
              </div>
              <p className="benefits-data-description">
                {item.title}
              </p>
            </div>
          ))}
        </div>
      </section>

      
      <section className="integration-option-sections">
        <h3 className="integration-title">
          <span>Integration </span> Options
        </h3>
        <p className="integration-description">
          We understand the importance of seamless integration with your
          existing systems and workflows. That's why we've made it as easy as
          possible to integrate our solution into your operations.
        </p>
      </section>
      <section
        className="integration-personas-card"
      >
        <div
          className="integration-card-block"
        >
          <div className="integration-card-inner-block row flex-row">
            <div className="col-lg-1 col-md-2 col-sm-3 integration-card-img">
              <img
                className="img-fluid"
                src="assets/images/react.png"
                alt=""
              />
            </div>
            <p className="integration-details col-lg-11 col-md-10 col-sm-9">
              Our APIs and integration tools are designed to work seamlessly
              with a wide range of systems, including HR platforms, benefits
              administration systems, and more. Our integration options allow
              access FootprintID® and FootprintId® with the same login
              credentials they use for other systems, creating a seamless
              experience.
            </p>
          </div>
        </div>
        <div
          className="integration-card-block"
        >
          <div className="integration-card-inner-block row flex-row">
            <div className="col-lg-1 col-md-2 col-sm-3 integration-card-img">
              <img
                className="img-fluid"
                src="assets/images/code.png"
                alt=""
              />
            </div>
            <p className="integration-details col-lg-11 col-md-10 col-sm-9">
              Our team will work closely with you to ensure a smooth integration
              process. We'll provide comprehensive documentation and support
              resources to help your IT team get up and running quickly. Our
              customer support team is also available 24/7 to answer any
              questions your employees may have about using FootprintID® and
              FootprintId.
            </p>
          </div>
        </div>
      </section>
      <section>
        <div>
          <h3 className="clients-say-businesses">
            <span>Ready to get started? </span>
          </h3>
          <div className="become-member-data">
            <Link target="_self" to={'/register'}>
              <button className="btn-deep-orange">Become a Member</button>
            </Link>
          </div>
        </div>
      </section>
    </div>
    </div>
  );
}

